import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Alert } from 'selenium-webdriver';
import { BaseComponent } from 'src/app/components/base/base.component';

@Component({
  selector: 'app-set-submit-time',
  templateUrl: './set-submit-time.component.html',
  styleUrls: ['./set-submit-time.component.scss'],
})
export class SetSubmitTimeComponent extends BaseComponent implements OnInit {
  minDate = '';
  toDate = '';
  @ViewChild('btnEdit') btnEdit: ElementRef;
  @ViewChild('btnAdd') btnAdd: ElementRef;
  ID_he = '';
  Khoa_hoc = '';
  Diem = '';
  ID_khoa = '';
  ID_lop = '';
  Ngay_bat_dau = '';
  Ngay_ket_thuc = '';

  dataQuyDinh = [];
  ngOnInit(): void {
    this.getToken();
    this.loadQuyDinh();
    this.GetHe();
    var current = new Date(new Date().setHours(new Date().getHours() + 0));
    this.minDate = new Date(current).toISOString().slice(0, 10);
  }

  loadQuyDinh() {
    this.AdminSystemService.LoadQuyDinh(this.Token).subscribe((z) => {
      this.dataTable = z.DataSinhHoatCongDongQuyDinh;
    });
  }

  GetHe() {
    this.LoadHeKhoaService.LoadHe(this.Token).subscribe((x) => {
      this.dataHe = x;
    });
  }
  lookDateTo() {
    var currentDateFrom = this.Action.controls.Ngay_bat_dau.value;
    debugger;
    var current = new Date(currentDateFrom);
    this.toDate = new Date(current).toISOString().slice(0, 10);
  }
  Action = new FormGroup({
    ID_he: new FormControl(null, [Validators.required]),
    Khoa_hoc: new FormControl(null, [Validators.required]),
    Diem: new FormControl(null, [Validators.required]),
    Ngay_bat_dau: new FormControl(null, [
      Validators.required,
      Validators.maxLength(500),
    ]),
    Ngay_ket_thuc: new FormControl(null, [
      Validators.required,
      Validators.maxLength(500),
    ]),
  });
  get checkvalue() {
    return this.Action.controls;
  }
  Insert() {
    this.submitted = true;
    if (this.Action.invalid) {
      return false;
    }
    var req = {
      ID_he: this.ID_he,
      ID_khoa: this.Khoa_hoc,
      Ngay_bat_dau: this.Ngay_bat_dau,
      Ngay_ket_thuc: this.Ngay_ket_thuc,
      Diem: this.Diem,
    };
    this.AdminSystemService.InsertQuyDinh(req, this.Token).subscribe((res) => {
      this.submitted = false;
      if (res.Status == 1) {
        this.toastr.success('Thêm mới thành công!');
        this.refesh();
      } else {
        this.toastr.warning(res.Message);
      }
    });
  }

  Update() {
    var req = {
      ID_he: this.ID_he,
      ID_khoa: this.Khoa_hoc,
      Ngay_bat_dau: this.Ngay_bat_dau,
      Ngay_ket_thuc: this.Ngay_ket_thuc,
      Diem: this.Diem,
    };
    this.AdminSystemService.UpdateQuyDinh(req, this.Token).subscribe((res) => {
      if (res.Status == 1) {
        this.btnAdd.nativeElement.style.display = 'block';
        this.btnEdit.nativeElement.style.display = 'none';
        this.Action.controls.ID_he.enable();
        this.Action.controls.Khoa_hoc.enable();
        this.toastr.success('Cập nhập thành công!');
        this.refesh();
      } else {
        this.toastr.warning(res.Message);
      }
    });
  }
  Detail(data) {
    this.btnAdd.nativeElement.style.display = 'none';
    this.btnEdit.nativeElement.style.display = 'block';

    //this.Action.controls.ID_he.disable();
    this.Action.controls.ID_he.disable();
    this.Action.controls.Khoa_hoc.disable();

    this.ID_he = data.ID_he;
    this.Khoa_hoc = data.ID_khoa;
    this.Diem = data.Diem;
    var expiryFrom = new Date(
      new Date(data.Ngay_bat_dau).setHours(new Date().getHours() + 10)
    );
    var expiryTo = new Date(
      new Date(data.Ngay_ket_thuc).setHours(new Date().getHours() + 12)
    );
    this.Ngay_bat_dau = new Date(expiryFrom).toISOString().slice(0, 10);
    this.Ngay_ket_thuc = new Date(expiryTo).toISOString().slice(0, 10);
  }

  Delete() {
    this.AdminSystemService.DeleteQuyDinh(
      this.ID_he,
      this.Khoa_hoc,
      this.Token
    ).subscribe((res) => {
      if (res.Status == 1) {
        this.toastr.success('Xoá thành công!');
        this.refesh();
      } else {
        this.toastr.warning(res.Message);
      }
      this.modalService.dismissAll('DeleteModal');
    });
  }

  open(content, sizm, type, data) {
    this.ID_he = data.ID_he;
    this.Khoa_hoc = data.ID_khoa;
    this.submitted = false;
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title', size: sizm })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  refesh() {
    this.ID_he = '';
    this.Khoa_hoc = '';
    this.Ngay_bat_dau = '';
    this.Ngay_ket_thuc = '';
    this.loadQuyDinh();
  }
}
